import { getUserConfiguration } from 'owa-session-store';
import type MailboxMessageConfigurationOptions from 'owa-service/lib/contract/MailboxMessageConfigurationOptions';
import type OptionsResponseBase from 'owa-service/lib/contract/OptionsResponseBase';
import mailboxMessageConfigurationOptions from 'owa-service/lib/factory/mailboxMessageConfigurationOptions';
import setMailboxMessageConfigurationRequest from 'owa-service/lib/factory/setMailboxMessageConfigurationRequest';
import setMailboxMessageConfigurationOperation from 'owa-service/lib/operation/setMailboxMessageConfigurationOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export default function setMailboxMessageConfiguration(
    newOptions: MailboxMessageConfigurationOptions
): Promise<OptionsResponseBase> {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (15,34): Object is possibly 'undefined'.
    // @ts-expect-error
    const timeIntervalOriginal = getUserConfiguration().UserOptions.MailSendUndoInterval;

    if (!newOptions.MailSendUndoInterval && timeIntervalOriginal && timeIntervalOriginal < 0) {
        newOptions.MailSendUndoInterval = 0;
    }

    return setMailboxMessageConfigurationOperation(
        setMailboxMessageConfigurationRequest({
            Header: getJsonRequestHeader(),
            Options: mailboxMessageConfigurationOptions(newOptions),
        })
    );
}
